import Vue from 'vue';
import store from '../../store';
import productPackagingTransformer from '../../transformers/productPackaging';

const success = ({ data }, resolve) => {
  const productPackagings = productPackagingTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProductPackagings', productPackagings);
  store.dispatch('setNullProductPackagings');

  resolve();
};

const failed = (error, reject) => reject(error);


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('product_packagings')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productPackaging/all.js